import { createContext } from 'react';

export type SocketContextValue = {
  connected: boolean;
  on: (event: string, callback: (data?: unknown) => void) => void;
  off: (event: string, callback?: (data?: unknown) => void) => void;
};

export const SocketContext = createContext<SocketContextValue | undefined>(undefined);
